import Button from 'components/base/Button';
import Modal from 'components/base/Modal';

import useModal from 'hooks/use-modal';

import { ModalOptions } from 'types/modal';

const MODAL_KEY = 'NOTICE';

type NoticeModalOptions = ModalOptions<typeof MODAL_KEY>;

export default function NoticeModalGuard() {
  const { activeModal, setModal } = useModal();

  const open = activeModal ? activeModal.type === MODAL_KEY : false;

  return (
    <NoticeModal
      open={open}
      onOpenChange={() => setModal(null)}
      {...(activeModal as NoticeModalOptions)}
    />
  );
}

type NoticeModalProps = NoticeModalOptions & {
  open: boolean;
  onOpenChange(): void;
};

export function NoticeModal(props: NoticeModalProps) {
  const { body, title, learnMoreLink, open, onOpenChange } = props;

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange}>
      <Modal.Content
        footer={
          <Modal.Footer>
            {learnMoreLink && (
              <Button variant="outline" size={1}>
                Learn more
              </Button>
            )}
            <Modal.Close asChild>
              <Button size={1} variant="primary">
                Okay
              </Button>
            </Modal.Close>
          </Modal.Footer>
        }
      >
        <Modal.BodyTitle title={title} description={body} />
      </Modal.Content>
    </Modal.Root>
  );
}
